<template>
  <section class="project-summary">

    <header>
      <c-title tag="h2">{{ title }}</c-title>
      <c-introduction v-if="abstract">
        <span v-html="abstract" />
      </c-introduction>
    </header>

    <div
      v-show="showDescription"
      :aria-hidden="showDescription ? 'false' : 'true'"
      :id="`${_uid}-description`"
      class="project-summary__description"
    >

      <img
        v-if="image"
        :src="image"
        alt=""
        class="project-summary__image"
      >

      <p
        v-for="(paragraph, index) in description.split(/\n\s*\n/g)"
        :key="index"
      >
        <span v-html="paragraph" />
      </p>

    </div>

    <c-button
      :aria-expanded="showDescription ? 'true' : 'false'"
      :aria-controls="`${_uid}-description`"
      type="button"
      @click="showDescription = !showDescription"
    >
      Beschreibung {{ showDescription ? 'ausblenden' : 'anzeigen' }}
    </c-button>

  </section>
</template>

<script>
import CButton from '@/components/CButton'
import CIntroduction from '@/components/CIntroduction'
import CTitle from '@/components/CTitle'

export default {
  name: 'CProjectSummary',

  components: {
    CButton,
    CIntroduction,
    CTitle
  },

  props: {
    abstract: {
      type: String
    },
    description: {
      type: String,
      required: true
    },
    image: {
      type: String
    },
    title: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      showDescription: false
    }
  }
}
</script>

<style scoped>
.project-summary {
  margin-bottom: var(--grid-spacing);
}

.project-summary::after {
  content: "";

  display: table;
  clear: both;
}

.project-summary__image {
  float: right;
  width: calc(100% / 3);
  margin: 8px 0 10px 20px;
}
</style>
